/** EAA-1829: split a list into consecutive slices of at most `size` items. */
export function chunk<T>(items: readonly T[], size: number): T[][] {
    if (size < 1) throw new RangeError('chunk size must be >= 1');
    const out: T[][] = [];
    for (let i = 0; i < items.length; i += size) out.push(items.slice(i, i + size));
    return out;
}
